export enum TerrainRenderingStatus {
    None,
    Loading = 'Loading',
    CreatingTexture = 'Creating Textrue',
    CreatingMesh = 'Creating Mesh',
    CreatingBVH = 'Creating BVH',
    Painting = 'Painting',
    Rendered = 'Rendered',
  }